(function () {
    var svgDesktop = document.getElementById('global-presence-worldmap');
    var svgMobile = document.getElementById('global-presence-worldmap-mobile');

    if (!svgDesktop || !svgMobile || typeof d3 === 'undefined' || typeof topojson === 'undefined') {
        return;
    }

    var wrap = document.getElementById('global-presence-map-wrap');
    var tip = document.getElementById('global-presence-tooltip');
    var pillsGrid = document.getElementById('global-presence-pills-grid');

    var countries = [
        'Australia', 'Belgium', 'Cayman Islands', 'Curaçao', 'Cyprus',
        'France', 'Guernsey', 'Hong Kong', 'India', 'Ireland',
        'Isle of Man', 'Italy', 'Japan', 'Jersey', 'Luxembourg',
        'Mainland China', 'Mauritius', 'New Zealand', 'Philippines', 'Singapore',
        'South Africa', 'Switzerland', 'The Netherlands', 'United Arab Emirates',
        'United Kingdom', 'United States'
    ];

    var dot = '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><circle cx="4.5" cy="4.5" r="4.5" fill="#7248BD"/></svg>';

    if (pillsGrid) {
        countries.forEach(function (name) {
            var pill = document.createElement('div');
            pill.className = 'global-presence__pill';
            pill.innerHTML = dot + name;
            pillsGrid.appendChild(pill);
        });
    }

    var offices = [
        { name: 'Australia', lon: 134.0, lat: -25.3 },
        { name: 'Belgium', lon: 4.4, lat: 50.8 },
        { name: 'Cayman Islands', lon: -81.3, lat: 19.3 },
        { name: 'Curaçao', lon: -68.9, lat: 12.1 },
        { name: 'Cyprus', lon: 33.0, lat: 34.7 },
        { name: 'France', lon: 2.3, lat: 48.9 },
        { name: 'Guernsey', lon: -2.5, lat: 49.5 },
        { name: 'Hong Kong', lon: 114.2, lat: 22.3 },
        { name: 'India', lon: 78.9, lat: 20.6 },
        { name: 'Ireland', lon: -6.3, lat: 53.3 },
        { name: 'Isle of Man', lon: -4.5, lat: 54.2 },
        { name: 'Italy', lon: 12.5, lat: 41.9 },
        { name: 'Japan', lon: 139.7, lat: 35.7 },
        { name: 'Jersey', lon: -2.1, lat: 49.2 },
        { name: 'Luxembourg', lon: 6.1, lat: 49.6 },
        { name: 'Mainland China', lon: 104.0, lat: 35.5 },
        { name: 'Mauritius', lon: 57.5, lat: -20.2 },
        { name: 'New Zealand', lon: 174.8, lat: -40.9 },
        { name: 'Philippines', lon: 122.0, lat: 12.8 },
        { name: 'Singapore', lon: 103.8, lat: 1.35 },
        { name: 'South Africa', lon: 25.0, lat: -29.0 },
        { name: 'Switzerland', lon: 8.2, lat: 46.8 },
        { name: 'The Netherlands', lon: 5.3, lat: 52.1 },
        { name: 'United Arab Emirates', lon: 54.4, lat: 24.5 },
        { name: 'United Kingdom', lon: -1.5, lat: 52.5 },
        { name: 'United States', lon: -98.0, lat: 38.0 }
    ];

    var w = 900;
    var h = 430;
    var proj = d3.geoNaturalEarth1()
        .scale(148)
        .translate([w / 2 + 10, h / 2 + 30])
        .clipExtent([[0, 0], [w, h]]);
    var path = d3.geoPath().projection(proj);

    function positionTooltip(event) {
        if (!wrap || !tip) {
            return;
        }

        var rect = wrap.getBoundingClientRect();
        var x = event.clientX - rect.left;
        var y = event.clientY - rect.top;
        var tipW = tip.offsetWidth;
        var tipH = tip.offsetHeight;
        var left = x > rect.width * 0.65 ? x - tipW - 14 : x + 14;

        tip.style.left = left + 'px';
        tip.style.top = Math.max(4, y - tipH / 2) + 'px';
    }

    fetch('https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json')
        .then(function (r) {
            return r.json();
        })
        .then(function (world) {
            var feat = topojson.feature(world, world.objects.countries);
            var noAntarctica = Object.assign({}, feat, {
                features: feat.features.filter(function (d) {
                    return +d.id !== 10;
                })
            });

            var desktop = d3.select('#global-presence-worldmap');
            desktop.selectAll('path')
                .data(noAntarctica.features).enter()
                .append('path').attr('class', 'global-presence__map-country').attr('d', path);

            desktop.selectAll('circle')
                .data(offices).enter()
                .append('circle')
                .attr('class', 'global-presence__map-dot')
                .attr('r', 5)
                .attr('cx', function (d) { return proj([d.lon, d.lat])[0]; })
                .attr('cy', function (d) { return proj([d.lon, d.lat])[1]; })
                .on('mouseenter', function (event, d) {
                    d3.select(this).attr('r', 7);

                    if (tip) {
                        tip.textContent = d.name;
                        tip.style.opacity = 1;
                    }

                    positionTooltip(event);
                })
                .on('mousemove', positionTooltip)
                .on('mouseleave', function () {
                    d3.select(this).attr('r', 5);

                    if (tip) {
                        tip.style.opacity = 0;
                    }
                });

            var mobile = d3.select('#global-presence-worldmap-mobile');
            mobile.selectAll('path')
                .data(noAntarctica.features).enter()
                .append('path').attr('class', 'global-presence__map-country').attr('d', path);

            mobile.selectAll('circle')
                .data(offices).enter()
                .append('circle')
                .attr('class', 'global-presence__map-dot')
                .style('cursor', 'default')
                .attr('r', 5)
                .attr('cx', function (d) { return proj([d.lon, d.lat])[0]; })
                .attr('cy', function (d) { return proj([d.lon, d.lat])[1]; });
        });
})();
